



































import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Mutation } from 'vuex-class'
import { ActionTypes, ErrorStatus } from '@/store/Base'
import { ApplicationState } from '@/store'
import { removeToken } from '@/helpers/token'

@Component
export default class App extends Vue {
	@State((state: ApplicationState) => {
		return state.Base.error
	})
	error!: ApplicationState['Base']['error']

	@State((state: ApplicationState) => {
		return state.Base.errorMessage
	})
	message!: ApplicationState['Base']['errorMessage']

	@Mutation(ActionTypes.SET_ERROR_STATUS) setErrorStatus!: (
		status: ErrorStatus
	) => void

	get status() {
		return this.error || 404
	}

	get customMessage() {
		return this.message || ''
	}

	get description() {
		console.log(this.status, this.customMessage)

		if (this.status == 503) {
			return `${this.customMessage}`
		}

		return `pageError.${this.status}`
	}

	resetError() {
		this.$router.go(-1)
		this.setErrorStatus(null)
	}

	logOut() {
		removeToken()
		window.localStorage.removeItem('userProfile')
		this.$store.state.myProfile = null
		this.$store.state.Base.error = null
		this.$router.push({ path: '/' })
	}

	goHome() {
		this.$router.push({ path: '/' })
		this.$store.state.Base.error = null
	}

	mounted() {
		if (this.status === 403) {
			setTimeout(() => {
				// console.log('Clear')

				localStorage.clear()
			}, 500)
		}
	}
}
